<template>
<div class="booking_conf_wrap">
    <div class="booking_expires">
        <p>Your booking expires in</p>
        <strong> {{hours | two_digits }} : {{minutes | two_digits}} : {{seconds | two_digits}} </strong>
        <span> {{vModel.StagingExpiryDate}}</span>
    </div>
    <div class="info_text">Visit any eRemit Pay partners and follow these steps to
        make payment
    </div>
    <div class="order_num">
        <strong> Show your Booking Order No. </strong>
        <span> {{vModel.StagingOrderNumber}} </span>
    </div>
    <div class="steps_count">
        <ul>
            <li>
                <div class="number-wrap"><span class="number"> 1 </span></div>
                <span class="barcode"><img :src="vModel.StagingBarCodeUrl"> </span>

            </li>
            <li>
                <div class="number-wrap"><span class="number"> 2 </span> </div>
                <span class="icon_img"><img src="/static/img/booking/icon1.png"> </span>
                <span class="txt_sc"> You will receive a confirmation SMS </span>

            </li>
            <li>
                <div class="number-wrap"><span class="number"> 3 </span> </div>
                <span class="icon_img"><img src="/static/img/booking/icon2.png"> </span>
                <span class="txt_sc"> Make payment </span>

            </li>
        </ul>
    </div>
</div>
</template>

<script>
import ListService from "../../services/list";
export default {
    name: "eremitPayDetail",
    props: ["vModel"],
    created() {
        this.date = Math.trunc(Date.parse(this.vModel.StagingExpiryDate) / 1000);
        var promises = [];
        promises.push(ListService.getCurrentDateTime())
        Promise.all(promises).then(response => {
            this.currentDateTime = response[0].body;
            console.log(this.currentDateTime)
        });

    },
    data() {
        return {
            now: null,
            date: null,
            currentDateTime: null
        }
    },
    mounted() {

        setTimeout(() => {
            let sec = (new Date(Date.parse(this.currentDateTime))).getTime();
            this.now = Math.trunc(sec / 1000);
        console.log(sec)
        setInterval(() => {
            sec = sec + 1000;
            this.now = Math.trunc(sec / 1000);
        }, 1000);    
        }, 1000);

        

    },
    computed: {
        seconds() {
            if(!this.now)
            return 0;
            return (this.date - this.now) % 60 > 0 ? (this.date - this.now) % 60 : 0;
        },
        minutes() {
            if(!this.now)
            return 0;
            return Math.trunc((this.date - this.now) / 60) % 60 > 0 ? Math.trunc((this.date - this.now) / 60) % 60 : 0;
        },
        hours() {
            if(!this.now)
            return 0;
            return Math.trunc((this.date - this.now) / 60 / 60) % 24 > 0 ? Math.trunc((this.date - this.now) / 60 / 60) % 24 : 0;
        },

    }

}
</script>

<style scoped>
.booking_expires {
    padding: 15px;
    background: #112338;
    border-radius: 10px;
    color: #fff;
    text-align: center;
    margin-bottom: 1.3em;
}

.booking_expires strong {
    display: block;
    color: #fab705;
    font-weight: bold;
    font-size: 20px;
}

.booking_expires p {
    margin: 0;
}

.order_num {
    text-align: center;
    margin-bottom: 1.1em;
}

.order_num strong {
    display: block;
}

.steps_count ul {
    list-style: none;
    padding: 0;
    margin: 0;
    align-items: center;
    justify-content: center;
}

.steps_count li img {
    max-width: 100%;
}

.steps_count ul li {
    display: flex;
    margin-bottom: 1.4em;
    align-items: center;
}

.steps_count ul li span.number {
    display: block;
    height: 30px;
    width: 30px;
    background: red;
    border-radius: 50%;
    text-align: center;
    line-height: 30px;
    color: #fff;
    font-weight: bold;
    margin-right: 1em;
}

span.barcode {
    flex-basis: 90%;
}

.steps_count ul li span.icon_img {
    flex-basis: 10%;
    display: block;
}

.number-wrap {
    flex-basis: 10%;
}

span.txt_sc {
    flex-basis: 80%;
}

.steps_count {
    display: flex;
    align-items: center;
    justify-content: center;
}

.info_text {
    font-weight: bold;
    color: #c1070e;
    max-width: 80%;
    margin: 0 auto;
    text-align: center;
    margin-bottom: 1em;
}
</style>
